import React from "react";
import { Trash2 } from "lucide-react";

const eur = (v) => `${v.toFixed(2).replace(".", ",")} €`;

// Ledger table (recettes or achats); manual rows (with id) can be deleted.
export function LedgerTable({ rows, partyLabel, empty, onDelete, testid }) {
  return (
    <div className="overflow-x-auto max-h-80 overflow-y-auto border border-border mb-4">
      <table className="w-full text-xs" data-testid={testid}>
        <thead className="bg-muted sticky top-0">
          <tr>{["Date", "N° pièce", partyLabel, "Nature", "Montant", ""].map((h, i) => <th key={i} className="text-left p-2 font-mono uppercase tracking-wider text-[10px]">{h}</th>)}</tr>
        </thead>
        <tbody>
          {rows.map((r, i) => (
            <tr key={r.id || i} className="border-t border-border" data-testid={`${testid}-row-${i}`}>
              <td className="p-2 whitespace-nowrap">{r.date}</td>
              <td className="p-2 font-mono">{r.number || "—"}</td>
              <td className="p-2">{r.client}</td>
              <td className="p-2">
                {r.label}
                {r.category === "goods" && partyLabel === "Client" && <span className="ml-1 font-mono text-[9px] px-1 border border-[#002FA7] text-[#002FA7]">MARCHANDISE</span>}
              </td>
              <td className={`p-2 text-right whitespace-nowrap font-bold ${r.amount < 0 ? "text-[#FF2A00]" : ""}`}>{eur(r.amount)}</td>
              <td className="p-2 w-8">
                {r.id && (
                  <button type="button" onClick={() => onDelete(r.id)} aria-label="Supprimer" data-testid={`${testid}-delete-${i}`}
                    className="text-muted-foreground hover:text-[#FF2A00] transition-colors"><Trash2 className="w-3 h-3" /></button>
                )}
              </td>
            </tr>
          ))}
          {rows.length === 0 && (
            <tr><td colSpan={6} className="p-4 text-center text-muted-foreground" data-testid={`${testid}-empty`}>{empty}</td></tr>
          )}
        </tbody>
      </table>
    </div>
  );
}

export default LedgerTable;
